module.exports = __webpack_public_path__ + "img/client_age_of_learning.2442b0cc.png";